import React, { Component } from 'react';
import { Responsive, Dropdown } from 'semantic-ui-react';
import { breakpoints } from 'helpers/breakpoints'
import styles from '../styles-module.css';
import { SELECT_ALL_LISTINGS, SELECT_SOME_LISTINGS } from '../../consts';
import { messages } from '../locale';

export class ListingFilter extends Component {
  handleFilterButtonClick(newSetting) {
    const { updateListingsFilterSetting, updateListingIds, setSelectedTicketTypes, setDataLoader } = this.props;
    setDataLoader(true);
    updateListingsFilterSetting(newSetting);
    if (newSetting === SELECT_ALL_LISTINGS) {
      updateListingIds([]);
      setSelectedTicketTypes({});
    }
  }

  render() {
    const {
      listingsFilterSetting,
      singleCurrency,
      selectedCurrency,
      hideFilterButtons,
      intl,
    } = this.props;

    const currencyCode = singleCurrency ? '' : selectedCurrency;
    const eventSelectorList = {
      SELECT_ALL_LISTINGS: {
        value: SELECT_ALL_LISTINGS,
        text: intl.formatMessage(messages.leftButton, { currencyCode })
      },
      SELECT_SOME_LISTINGS: {
        value: SELECT_SOME_LISTINGS,
        text: intl.formatMessage(messages.rightButton, { currencyCode })
      }};

    const selectedEventFilter = () => listingsFilterSetting === SELECT_ALL_LISTINGS
      ? eventSelectorList.SELECT_ALL_LISTINGS.value
      : eventSelectorList.SELECT_SOME_LISTINGS.value;
    const buttonBarClasses = `${styles.buttonBar} ${hideFilterButtons ? styles.hidden : ''}`;
    const allEventButtonClasses = `${styles.button} ${listingsFilterSetting === SELECT_ALL_LISTINGS && styles.active}`;
    const specificEventsButtonClasses = 
      `${styles.button} ${listingsFilterSetting === SELECT_SOME_LISTINGS && styles.active}`;

    return (
      <>
        <Responsive minWidth={breakpoints.largestMobile + 1}>
          <div className={buttonBarClasses}>
            <div
              className={allEventButtonClasses}
              onClick={() => this.handleFilterButtonClick(SELECT_ALL_LISTINGS)}
              role="button"
              tabIndex={0}
            >
              {eventSelectorList.SELECT_ALL_LISTINGS.text}
            </div>
            <div className={styles.buttonDivider}/>
            <div
              className={specificEventsButtonClasses}
              onClick={() => this.handleFilterButtonClick(SELECT_SOME_LISTINGS)}
              role="button"
              tabIndex={0}
            >
              {eventSelectorList.SELECT_SOME_LISTINGS.text}
            </div>
          </div>
        </Responsive>
        <Responsive
          maxWidth={breakpoints.largestMobile}
          className={styles.eventSelectionFilter}
        >
          <Dropdown
            onChange={(_, { value }) => {
              this.handleFilterButtonClick(value);
            }}
            selection
            options={Object.values(eventSelectorList)}
            value={selectedEventFilter()}
            className={styles.selector}
          />
        </Responsive>
      </>
    );
  }
}

export default ListingFilter;
